/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-16 10:52:49
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-26 12:54:34
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelPreviewPageComponents/AutoPlay/index.tsx
 */
/**
 *  Autoplay Component
 *  Author: Luke
 *  CreatedAt: 2021-03-08
 */
import { get } from 'lodash';
import React from 'react';
import { Checkbox, NumberInput } from 'src/components/Antd';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Field } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import {
  autoPlayCheckbox,
  autoPlayInterval,
} from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const AutoPlay = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled } = props;

  return (
    <Section {...sectionProps}>
      <ItemWrapper>
        <div className={css.container}>
          <Field name={autoPlayCheckbox} valuePropName={'checked'}>
            <Checkbox disabled={disabled}>
              {getI18n('general.autoplay')}
            </Checkbox>
          </Field>
          <div className={css.tip}>{getI18n('general.intervaltime')}</div>
          <div className={css.numberInputContainer}>
            <Field
              shouldUpdate={(p, c) => {
                const pV = get(p, autoPlayCheckbox);
                const cV = get(c, autoPlayCheckbox);
                return cV !== pV;
              }}>
              {(props, meta, { getFieldValue, setFields, setFieldsValue }) => {
                const isAuto = getFieldValue(autoPlayCheckbox);
                return (
                  <Field name={autoPlayInterval}>
                    <NumberInput
                      className={css.numberInput}
                      disabled={!isAuto || disabled}
                      suffix={getI18n('general.seconds')}
                      size='large'
                      min={1}
                    />
                  </Field>
                );
              }}
            </Field>
          </div>
        </div>
      </ItemWrapper>
    </Section>
  );
};
export default AutoPlay;
